import { useSelector } from 'react-redux';
import { ReduxState } from '../../../../store';
import { EntityListProductInputData, EntityListTypeSupported } from '../entityListsLib';
import { EntityListState } from '../entityListAdministrationSlice';

/**
 * Uses selected entity list of given type and retrieves its state from the Redux store.
 * Every Entity List maintains its own state in terms of current import step, imported data etc
 * @param entityListType
 * @return {EntityListState<EntityListTypeSupported> | undefined} Undefined if no entity list is selected or data is not available
 */
export const useCurrentEntityListState = (
  entityListType: EntityListTypeSupported,
): EntityListState<EntityListTypeSupported, EntityListProductInputData> | undefined => {
  const selectedEntityList = useSelector(
    (state: ReduxState) => state.entityListsAdministration[entityListType].selectedEntityList,
  );

  return useSelector((state: ReduxState) => {
    const imports = state.entityListsAdministration[entityListType].imports;
    if (selectedEntityList && selectedEntityList.entityListId in imports) {
      return imports[selectedEntityList.entityListId];
    } else {
      return undefined;
    }
  });
};
